import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import defaultStaffPhoto from "assets/defaultStaffPhoto.jpeg";
import "./StaffTeaser.css";

const STAFF_PREVIEW_COUNT = 3;

const StaffTeaser = () => {
  const staff = useSelector((state) => state.contentfulReducer.staff);

  const featured = staff
    .filter((member) => member.fields.showOnHome)
    .slice(0, STAFF_PREVIEW_COUNT);

  const preview =
    featured.length > 0 ? featured : staff.slice(0, STAFF_PREVIEW_COUNT);

  if (preview.length === 0) {
    return null;
  }

  const scrollToTop = () => window.scrollTo(0, 0);

  return (
    <section
      className="home-section home-section--alt"
      aria-labelledby="staff-heading"
    >
      <div className="home-section__inner">
        <header className="home-section__header home-staff__header">
          <div>
            <h2 id="staff-heading" className="home-section__title">
              Meet Our Team
            </h2>
            <p className="home-section__subtitle">
              Experienced coaches who care about every athlete.
            </p>
          </div>
          <Link
            to="/staff"
            onClick={scrollToTop}
            className="home-btn home-btn--outline"
            data-track="staff_nav_click"
            data-track-location="home_staff_teaser"
          >
            View full team
          </Link>
        </header>
        <div className="home-staff-grid">
          {preview.map((member) => {
            const photo =
              member.fields.staffPhoto?.fields?.file?.url || defaultStaffPhoto;
            return (
              <article key={member.fields.name} className="home-staff-card">
                <div className="home-staff-card__photo">
                  <img
                    src={photo}
                    alt={`${member.fields.name}, ${member.fields.jobTitle} at Ace Gymnastics`}
                    width="200"
                    height="200"
                    loading="lazy"
                  />
                </div>
                <h3 className="home-staff-card__name">{member.fields.name}</h3>
                <p className="home-staff-card__role">{member.fields.jobTitle}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StaffTeaser;
